import { useState, useEffect, useCallback } from 'react';
import { auditAPI } from '../api/audit';

export function useAuditStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    auditAPI.getStats()
      .then(setStats)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return { stats, loading, error };
}

export function useAuditLogs(filters, page, limit = 50) {
  const [data, setData]         = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await auditAPI.getAll(filters, page, limit);
      setData(res.data);
      setPagination(res.pagination);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  }, [JSON.stringify(filters), page, limit]); // eslint-disable-line

  useEffect(() => { load(); }, [load]);

  return { data, pagination, loading, error, reload: load };
}
